import React from 'react';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
    return (
        <div className="flex justify-center items-center gap-2 mt-8 mb-4">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`flex items-center gap-1 px-4 py-2 text-sm ${
                    currentPage === 1
                        ? 'text-gray-600 cursor-not-allowed'
                        : 'text-gray-300 hover:text-white'
                }`}
            >
                ← Previous
            </button>

            <div className="flex items-center gap-1">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`px-4 py-2 text-sm rounded-md ${
                            currentPage === page
                                ? 'bg-[#1A1721] text-white'
                                : 'text-gray-400 hover:text-white'
                        }`}
                    >
                        {page}
                    </button>
                ))}
            </div>

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`flex items-center gap-1 px-4 py-2 text-sm ${
                    currentPage === totalPages
                        ? 'text-gray-600 cursor-not-allowed'
                        : 'text-gray-300 hover:text-white'
                }`}
            >
                Next →
            </button>
        </div>
    );
};

export default Pagination; 